

document.addEventListener("DOMContentLoaded", function () {
  setupVariantSelectors();
});

function setupVariantSelectors() {
  const products = document.querySelectorAll("custom-variant-selector");

  products.forEach((product) => {
    const variantSpans = product.querySelectorAll(".new_var_select");

    const firstAvailable = Array.from(variantSpans).find(
      (span) => !span.hasAttribute("disabled")
    );

    if (firstAvailable) {
      activateVariant(firstAvailable, product);
    }

    variantSpans.forEach((span) => {
      span.addEventListener("click", function (e) {
        e.preventDefault();
        if (span.hasAttribute("disabled")) return;
        activateVariant(span, product);
      });
    });
  });

  function activateVariant(span, product) {
    const variantSpans = product.querySelectorAll(".new_var_select");

    variantSpans.forEach((s) => s.classList.remove("active"));
    span.classList.add("active");

    const variantId = span.getAttribute("variant-new-attr");
    const variantPriceAttr = span.getAttribute("variant-price-attr");
    const variantCompAttr = span.getAttribute("variant-comp-price-attr");
    const variantImage = span.getAttribute("variant-image");

    const variantPrice = parseFloat(
      variantPriceAttr?.replace(/[^0-9.]/g, "")
    );
    const variantCompPrice = parseFloat(
      variantCompAttr?.replace(/[^0-9.]/g, "")
    );

    const cardWrapper = span.closest(".card-wrapper");
    if (!cardWrapper) return;

    const inputId = cardWrapper.querySelector('input[name="id"]');
    if (inputId && variantId) {
      inputId.value = variantId;
    }

    const salePriceEl = cardWrapper.querySelector(
      ".price__sale .price-item--sale"
    );

    if (salePriceEl && !isNaN(variantPrice)) {
      salePriceEl.textContent = "₹" + Math.round(variantPrice);
    }

    const compareEl = cardWrapper.querySelector(
      ".price__sale s.price-item--regular"
    );

    if (compareEl) {
      if (!isNaN(variantCompPrice) && variantCompPrice > variantPrice) {
        compareEl.textContent = "₹" + Math.round(variantCompPrice);
        compareEl.style.display = "inline";
      } else {
        compareEl.style.display = "none";
      }
    }

    const discountWrap = cardWrapper.querySelector(".discount");
    const discountText = cardWrapper.querySelector(
      ".discount .dis-txt-off"
    );

    if (
      discountWrap &&
      discountText &&
      !isNaN(variantCompPrice) &&
      !isNaN(variantPrice) &&
      variantCompPrice > variantPrice
    ) {
      const discountPercent = Math.round(
        ((variantCompPrice - variantPrice) / variantCompPrice) * 100
      );

      discountText.textContent = discountPercent + "%";
      discountWrap.style.display = "flex";
    } else if (discountWrap) {
      discountWrap.style.display = "none";
    }

    const imgTag = cardWrapper.querySelector(".media img");

    if (imgTag && variantImage) {
      imgTag.src = variantImage;
      imgTag.srcset = variantImage;
    }
  }
}


// Read less and read more

  document.querySelectorAll(".readmore-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const wrapper = btn.closest(".readmore-wrapper");

      wrapper.classList.toggle("expanded");

      btn.textContent = wrapper.classList.contains("expanded")
        ? "Read Less"
        : "Read More";
    });
  });